'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './contact-list.routes';

export class ContactListComponent {
  constructor(Auth, ContactService, dialogs, DTOptionsBuilder, DTDefaultOptions, DTState, Util) {
    'ngInject';

    this.ContactService = ContactService;
    this.data = [];

    this.dialogs = dialogs;

    DTDefaultOptions.setLoadingTemplate( "<datatable-loading-placeholder columns='Name, Address, Phone, Mail, Creation Date' />");

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('deferRender', true)
      .withOption('initComplete', _=> {this.initComplete = true})
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Contacts",
        exportOptions: {
          orthogonal: 'export',
        }
      },{
        extend: 'csv',
        title: "Contacts",
        exportOptions: {
          orthogonal: 'export',
        }
      },{
        title: "Contacts",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER',
        exportOptions: {
          orthogonal: 'export',
        }
      },{
        extend: 'print',
        title: "Contacts",
        exportOptions: {
          orthogonal: 'export',
        }
      }]);

    this.dtOptions.columnDefs = [ {
      targets: [0, 1],
      render: Util.dataTableExportBreakToNewlineRenderer
    }];

    this.ContactService.query(data => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve contacts.");
    });
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryEmailSoftBreak(contact) {
    let email = this.getPrimaryEmail(contact);

    return email
      .replace('@','@&#8203;')
      .replace('.','&#8203;.')
      .replace('-','-&#8203;')
      .replace('_','_&#8203;');
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryPhone(contact) {
    if (!contact || !contact.phone || !contact.phone.length)
      return "-";

    let phone = contact.phone.find(phone => phone.isPrimary) || contact.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(contact) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    return address.street + "<br/>" + address.city + ', ' + address.state + ' ' + address.zip;
  }

  delete(contact) {
    var that = this;

    var contactText = "<br/><br/><b>" + contact.lastName + "</b><br/><p>" + contact.firstName + "</p>";

    var dlg = this.dialogs.confirm("Delete Contact?", "Do you really want to delete this contact?" + contactText);
    dlg.result.then(() => {
      // OK delete it
      that.ContactService.delete({id: contact._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== contact._id;
          });
        },
        err => {
          alert("Could not delete contact");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.contactList', [uiRouter])
  .config(routes)
  .component('contactList', {
    template: require('./contact-list.html'),
    controller: ContactListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-list/contact-list.component.js